import { motion } from "framer-motion";

// During static prerendering the page is never scrolled, so framer-motion's
// `whileInView` reveals would stay at opacity:0 and hide the text from crawlers.
// Detect the prerender bot and render fully-visible static markup instead.
const isPrerender =
  typeof navigator !== "undefined" && /Prerender/i.test(navigator.userAgent);

export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => {
  if (isPrerender) {
    return <div className={className}>{children}</div>;
  }
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
